import React, { useEffect, useRef } from 'react'
import { node, string, func, bool } from 'prop-types'
import { BackDrop, Button } from '../'
import { closeIcon } from '../../assets/icon'
import { trapFocus } from 'services/utils'

const Modal = ({
  title,
  children,
  onClose,
  cancelButtonLabel,
  okButtonLabel,
  okButtonClassName,
  cancelButtonClassName,
  onSubmit,
  showCloseIcon,
  loading,
  isError,
  className,
  prevFocusableElement,
  closeModalOnSubmitClick
}) => {

  useEffect(() => {
    toggleModal()
  })

  useEffect(() => {
    const handleKeyUp = (e) => {
      const keys = {
        27: () => {
          e.preventDefault()
          closeModal()
          closeModalOnSubmitClick && submitModal()
          document.removeEventListener('keyup', handleKeyUp, true)
        },
      };
  
      if (keys[e.keyCode]) { keys[e.keyCode](); }
    }
    document.addEventListener('keyup', handleKeyUp, true)
  })

  let trapped;
  const ref = useRef(null);

  const closeModal = () => {
    onClose()
    !(onClose === Modal.defaultProps.onClose) && trapped.onClose() 
  }

  const submitModal = () => {
    onSubmit()
    trapped.onClose()
  }

  const toggleModal = ((e) => {
    const modal = ref.current
    trapped = trapFocus(modal, prevFocusableElement)
  })

  return (
    <div className={className}>
      <BackDrop color='black' onClick={closeModal} />
      <div className="modal" ref={ref}>
        <div className="modal-title">
          { isError ? `Try again` : title }
        </div>
        { showCloseIcon &&
        <Button
          onClick={closeModal}
          type="button"
          className="close-icon"
          aria-hidden="true"
        >
          <img
            src={closeIcon}
            alt="x"
          />
        </Button>
        }
        <div className="modal-content">
          { children }
        </div>
        <div className="modal-footer">
          { cancelButtonLabel &&
          <Button
            type="button"
            onClick={closeModal}
            className={cancelButtonClassName}
          >
            {cancelButtonLabel}
          </Button>}
          { okButtonLabel &&
          <Button
            type="button"
            onClick={submitModal}
            className={`${okButtonClassName} ${cancelButtonLabel ? 'half' : 'full'}`}
            loading={loading}
          >
            {okButtonLabel}
          </Button>
          }
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  children: node,
  title: string,
  onClose: func,
  cancelButtonLabel: string,
  okButtonLabel: string,
  onSubmit: func,
  showCloseIcon: bool,
  okButtonClassName: string,
  cancelButtonClassName: string,
  loading: bool,
  isError: bool,
  className: string,
}

Modal.defaultProps = {
  children: null,
  title: '',
  onClose: x => x,
  cancelButtonLabel: '',
  okButtonLabel: '',
  onSubmit: x => x,
  showCloseIcon: false,
  okButtonClassName: 'secondary',
  cancelButtonClassName: 'basic half',
  loading: false,
  isError: false,
  className: '',
  closeModalOnSubmitClick: false
}

export default Modal
